import {takeLatest} from 'redux-saga/effects';
import * as saga from './saga';
import * as ACTION from './constants';

export default function*() {
    yield takeLatest(ACTION.FETCH_USERS.REQUEST, saga.fetchUsers);
    yield takeLatest(ACTION.FETCH_DETAIL_USERS.REQUEST, saga.fetchDetailUser);
}
